import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f879f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jtabs-main" }
const _hoisted_2 = { class: "jtabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "jtabs-item-left"
}
const _hoisted_5 = { class: "jtabs-item-context" }
const _hoisted_6 = {
  key: 1,
  class: "jtabs-item-right"
}

import { onMounted, PropType, ref, watch } from "vue";
import JScroll, { IScrollDataItem } from '../jscroll/index.vue';

export interface ITabsDataItem extends IScrollDataItem {
    /**
     * 选中值
     */
    id: string | number;
    /**
     * 选中value
     */
    value: string;
    /**
     * 是否选中
     */
    select?: boolean;
}

//---------------------传入参数、回调、监听定义---------------------
//定义传入变量

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    //列表数据
    data: {
        required: true,
        type: Array as PropType<ITabsDataItem[]>,
        default: () => {
            return []
        },
    },
    //默认选中的选项
    select: {
        required: false,
        type: String,
        default: '',
    }
},
  emits: ["switchTabs"],
  setup(__props, { emit }: { emit: ({
    (e: "switchTabs", item: ITabsDataItem): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;


//定义监听事件
watch(
    () => props.data,
    (newVal: any) => {
        //变更执行事件
        updateItem(newVal)
    }
);

watch(
    () => props.select,
    (newVal: any) => {
        //变更执行事件
        updateItem(props.data)
    }
);

//定义回调事件




//定义生命周期事件
onMounted(() => {
    //生命周期处理内容
    updateItem(props.data)
});


// ---------------------数据变量定义-------------------------
//变量定义
let list = ref<ITabsDataItem[]>([]);


// ---------------------方法定义-------------------------

const selectItem = function (item: ITabsDataItem): string {
    emit("switchTabs", item);
    list.value = list.value.map((e) => {
        let isSelect = false;
        if (item.value && item.id === e.id) {
            isSelect = true;
        }
        return { id: e.id, value: e.value, select: isSelect }
    })

    return "";
};



const getItem = (index: number) => {
    return list.value[index <= 0 ? 0 : index];
}

const updateItem = (itemList: ITabsDataItem[]) => {
    //更新数据结构
    list.value = itemList.map((e) => {
        let isSelect = e.select;
        if (props.select && props.select === e.id) {
            isSelect = true;
        }
        return { id: e.id, value: e.value, select: isSelect }
    })

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(JScroll, {
          class: "jtabs-scroll",
          direction: "row",
          spacing: 200,
          style: {"width":"100%"},
          list: _unref(list)
        }, {
          cell: _withCtx(({ index }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["jtabs-item", {
                            'jtabs-item-first': index === 0 ? true : false, 'jtabs-item-active': getItem(index).select, 'jtabs-item-last': (index === _unref(list).length ? true : false), 'jtabs-item-border': getItem(index - 1).select
                        }]),
              onClick: ($event: any) => (selectItem(getItem(index)))
            }, [
              (getItem(index).select && index !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, _toDisplayString(getItem(index).value), 1),
              (getItem(index).select)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                : _createCommentVNode("", true)
            ], 10, _hoisted_3)
          ]),
          _: 1
        }, 8, ["list"])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})